import {HttpModelConverter} from '../../core/converter/httpModel.converter';
import {AddressModel} from '../entity/address.model';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AddressConverter extends HttpModelConverter<AddressModel> {

    protected createInstance(): AddressModel {
        return new AddressModel();
    }

    protected enrichObject(result: AddressModel, src: AddressModel) {
    }



}
